import React from "react";
import { StyledCardAvisosOptions } from "../../styled-components/StyledCardAvisosOptions.style";
import { StyledCircleItem } from "../../styled-components/StyledCircleItem.style";
import moment from "moment";
import Flex from '@react-css/flex';
import { Link } from "react-router-dom";
import Swal from "sweetalert2";


export const CardAvisos = (props) => {
    const { avisoObject, setMarcarLido = { setMarcarLido } } = props;

    const formatData = (data) => {

        if (data) {
            return moment(new Date(data)).format("DD/MM/YYYY HH:mm");
        }

        return "--";

    }


    const openMsg = () => {

        const title = `<strong style="font-size: 18px; text-aling">Aviso ${formatData(avisoObject?.dataNotificacao)}</strong>`
        const text = `<p>${avisoObject?.assunto}</p>`

        Swal.fire({
            title: title,
            html: text,
            showCloseButton: true,
            showCancelButton: true,
            showConfirmButton: false,
            focusConfirm: false,
            cancelButtonText: `Fechar`,
        });
    }


    return (
        <StyledCardAvisosOptions >

            <div className="card-align">
                <Flex>

                    <Flex.Item className="flex-column-left">
                        <span className="legend-time">  {formatData(avisoObject?.dataNotificacao)}</span>
                    </Flex.Item>
                    <Flex.Item className="flex-title-right">
                        {
                            !avisoObject?.marcarLido ? (
                                <div onClick={() => setMarcarLido(avisoObject?.idNotificacaoUsuario, true)}>
                                    <StyledCircleItem
                                        size="18px"
                                        borderColor="#f9bd0ae3"
                                        backgroundColor="#f9bd0ae3"
                                        title="Não Lido"
                                    />
                                </div>

                            ) : (
                                <div onClick={() => setMarcarLido(avisoObject?.idNotificacaoUsuario, false)}>
                                    <StyledCircleItem
                                        size="18px"
                                        borderColor="#32A814"
                                        backgroundColor="#32A814"
                                        title="Lido"
                                    />
                                </div>
                            )
                        }
                    </Flex.Item>

                </Flex>

                <Flex>
                    <Flex.Item className="flex-text-justify text-max-3-lines">
                        <p onClick={openMsg}> <span className="legend-title-text-bold">Assunto: </span>{avisoObject?.assunto} </p>
                    </Flex.Item>
                </Flex>

                {(() => {
                    if (avisoObject?.idReference) {
                        return (
                            <Flex>
                                <Flex.Item className="flex-column-right-100">
                                    <Link title="Detalhes TS" target="_blank" className="menu-link" to={{ pathname: "/timesheetdetalhespage/", hash: avisoObject?.idReference }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                            <path fillRule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                        </svg>
                                    </Link>
                                </Flex.Item>
                            </Flex>
                        )
                    }
                    return null
                })()}


            </div>
        </StyledCardAvisosOptions>
    );
};
